import { apiClient } from './client';

/**
 * Get quizzes for a course
 * @param {string} courseId
 * @param {{ page?, limit?, search?, sortBy?, sortOrder? }} params
 */
export async function getQuizzes(courseId, params = {}) {
  const { data } = await apiClient.get(`/quizzes/courses/${courseId}`, { params });
  return data;
}

/**
 * Alias: list all quizzes (with questions + correct answers) for a course.
 * Used by CRM Courses page to display quiz coverage metrics.
 */
export async function getQuizzesByCourse(courseId) {
  const { data } = await apiClient.get(`/quizzes/courses/${courseId}`);
  return data;
}

/**
 * Get single quiz
 * @param {string} courseId
 * @param {string} quizId
 */
export async function getQuiz(courseId, quizId) {
  const { data } = await apiClient.get(`/quizzes/${quizId}`);
  return data;
}

/**
 * Create a quiz for a lesson
 * @param {string} lessonId
 * @param {object} body - questions (array), passingScore?, timeLimitMinutes (null = no limit),
 *   expectedVersion (0 = the lesson has no quiz yet; the API answers 409 if one appeared meanwhile)
 */
export async function createQuiz(lessonId, body) {
  const { data } = await apiClient.post(`/quizzes/lessons/${lessonId}`, body);
  return data;
}

/**
 * Update a quiz. A save creates a new quiz version, so each existing question must go back with its
 * server `id` and its imageUrl/imageAlt, or the new version loses its picture.
 * @param {string} courseId
 * @param {string} quizId
 * @param {object} body - questions, passingScore (only when changed), timeLimitMinutes (null = no limit),
 *   expectedVersion (the version the editor opened; the API answers 409 if the quiz moved on)
 */
export async function updateQuiz(courseId, quizId, body) {
  const { data } = await apiClient.patch(`/quizzes/${quizId}`, body);
  return data;
}

/**
 * Delete a quiz.
 * @param {string} courseId
 * @param {string} quizId
 */
export async function deleteQuiz(courseId, quizId) {
  const { data } = await apiClient.delete(`/quizzes/${quizId}`);
  return data;
}

/**
 * Get quiz attempts (results)
 * @param {string} courseId
 * @param {string} quizId
 * @param {{ page?, limit?, status?, sortBy?, sortOrder? }} params
 */
export async function getQuizAttempts(courseId, quizId, params = {}) {
  const { data } = await apiClient.get(`/quizzes/${quizId}/attempts`, { params });
  return data;
}

/**
 * Get single quiz attempt details
 * @param {string} courseId
 * @param {string} quizId
 * @param {string} attemptId
 */
export async function getQuizAttempt(courseId, quizId, attemptId) {
  const { data } = await apiClient.get(`/quizzes/attempts/${attemptId}`);
  return data;
}
